import React from 'react';
import {ReactComponent as CloseIcon} from './close.svg';
import {useTranslation} from 'react-i18next';
import {getRules} from '../../../spirsApi/api-client';
import {useSelector} from 'react-redux';
import {StoreType} from '../../../store/spirs/types';
import {Dialog} from "../../dialog/Dialog";

interface RulesModalProps {
    openModal: boolean;
    setOpenModal: (open: boolean) => void;
}

export function RulesModal(props: RulesModalProps) {
    const {t} = useTranslation();
    const playerId = useSelector((state: StoreType) => state.spirs.playerInfo.playerId);

    const [rule, setRule] = React.useState<string>('');

    function closeDialog() {
        props.setOpenModal(false);
    }

    React.useEffect(() => {
        setRule('');
        getRules({
            player: playerId,
        }).then((response) => {
            response && setRule(response.content);
        });
    }, []);


    return (
        <Dialog
            isOpen={props.openModal}
            onClose={closeDialog}
        >
            <div className={'flex'}>
                <div className={"bg-white text-black text-[16px] rounded-[8px] overflow-y-scroll p-[27px] h-[90vh] w-[90vw]"}>
                    <div className={'flex justify-between'}>
                        <div className={"text-[16px] tablet:text-[24px] font-bold"}>
                            {t('rulesList.title')}
                        </div>
                        <div
                            className="cursor-pointer p-[5px] h-full rounded-[100%] hover:bg-grey"
                            onClick={closeDialog}
                        >
                            <CloseIcon/>
                        </div>
                    </div>
                    <div>
                        {rule != ''
                            ? <div dangerouslySetInnerHTML={{__html: rule}} />
                            : <div>Loading...</div>}
                    </div>
                </div>
            </div>
        </Dialog>
    );
}


